import { Goal, GoalStatus } from '@griply/types';

// Archived wins: archiving keeps completedAt, and the archive is what the user last decided.
export const getGoalStatus = (
  goal: Pick<Goal, 'archivedAt' | 'completedAt'>,
): GoalStatus | null => {
  if (goal.archivedAt) {
    return GoalStatus.Archived;
  }
  if (goal.completedAt) {
    return GoalStatus.Completed;
  }
  return null;
};
